<!--Login Page Starts-->
<section id="login">
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-body auth-img">
            <div class="row m-0">
              <div class="col-lg-6 d-none d-lg-flex justify-content-center
                align-items-center auth-img-bg p-3">
                <img src="assets/img/gallery/login.png" alt="" class="img-fluid" width="300" height="230">
              </div>
              <div class="col-lg-6 col-12 px-4 py-3">
                <h4 class="mb-2 card-title">Login</h4>
                <p>Welcome back, please login to your account.</p>
                <ngb-alert type="light-danger" class="mb-2" *ngIf="isLoginFailed" (close)="isLoginFailed= false">
                  <p class="mb-0">Login failed!</p>
                </ngb-alert>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                  <div class="form-group">
                    <input type="email" formControlName="email" name="email" id="email" class="form-control" placeholder="email or phone" [ngClass]="{ 'is-invalid': loginFormSubmitted &&
                      lf.email.invalid, 'is-valid': loginFormSubmitted &&
                      !lf.email.invalid }" required>
                    <div *ngIf="loginFormSubmitted && (lf.email.invalid ||
                      lf.email.errors?.required)" class="help-block mt-1 text-danger"> <i
                        class="ft-alert-circle align-middle"></i> This is
                      required</div>
                  </div>
                  <div class="form-group">
                    <input type="password" formControlName="password" name="password" id="password"  class="form-control" placeholder="Password"
                      [ngClass]="{ 'is-invalid': loginFormSubmitted &&
                      lf.password.invalid, 'is-valid': loginFormSubmitted &&
                      !lf.password.invalid }" required>
                    <div *ngIf="loginFormSubmitted && (lf.password.invalid ||
                      lf.password.errors?.required)" class="help-block mt-1 text-danger"> <i
                        class="ft-alert-circle align-middle"></i> This is
                      required
                    </div>
                  </div>
                  <div class="d-sm-flex justify-content-between mb-3
                    font-small-2">
                    <div class="remember-me mb-2 mb-sm-0">
                      <div class="checkbox auth-checkbox">
                        <input type="checkbox" formControlName="rememberMe" class="form-control" id="rememberMe" name="rememberMe">
                        <label for="rememberMe"><span class="font-small-2 mb-3
                            font-weight-normal">Remember Me</span></label>
                      </div>
                    </div>
                    <a [routerLink]="['/forgotpassword']">Forgot Password?</a>
                  </div>
                  <div class="d-flex justify-content-between flex-sm-row
                    flex-column ">
                    <a [routerLink]="['/connect-to-learn']" class="btn
                      bg-light-primary mb-2 mb-sm-0">Connect to Learn</a>
                    <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid">Login</button>
                  </div>
                </form>
                <hr>
                <div class="d-flex justify-content-between align-items-center">
                  <ngx-spinner></ngx-spinner>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Login Page Ends-->